export const toggleProjectListFilterView = (projectListFilterView) => ({
    type: "TOGGLE_PROJECT_LIST_FILTER_VIEW",
    projectListFilterView
});

export const toggleProjectListFilterOptionsExpanded = (projectListFilterOptionsExpanded) => ({
    type: "TOGGLE_PROJECT_LIST_FILTER_OPTIONS_EXPANDED",
    projectListFilterOptionsExpanded
});

export const setProjectListFilters = (projectListFilters) => ({
    type: "SET_PROJECT_LIST_FILTERS",
    projectListFilters
});

export const setAutomaticProjectListFilters = (automaticProjectListFilters) => ({
    type: "SET_AUTOMATIC_PROJECT_LIST_FILTERS",
    automaticProjectListFilters
});

export const setFloorPlanListFilters = (floorPlanListFilters) => ({
    type: "SET_FLOOR_PLAN_LIST_FILTERS",
    floorPlanListFilters
});

export const setProjectSort = (projectSort) => ({
    type: "SET_PROJECT_SORT",
    projectSort
});